import React, { useRef, useCallback } from 'react';
import { Node } from 'reactflow';
import { NodeData, Nodetype } from '../types';
import { Position } from '../types';
import Title from '../../../../components/forms/titles.component';
import Button from '../../../../components/forms/button.component';
import Icon from '../../../../components/forms/icon.component';
import DefaultNodeForm from '../../../../components/nodes/form/default-node-form.component';
import InteractiveNodeForm from '../../../../components/nodes/form/interactive-node-form.component';
import HttpNodeForm from '../../../../components/nodes/form/http-node-form.component';
import RedirectAgentNodeForm from '../../../../components/nodes/form/redirect-node-form.component';
import CloseNodeForm from '../../../../components/nodes/form/close-node-form.component';

interface NodeSidePanelProps {
  selectedNode: Node<NodeData>;
  onSave: (nodeId: string, data: NodeData, position: Position) => void;
}

interface FormProps {
  node: Node<NodeData>;
  onSave: (nodeId: string, data: NodeData, position: Position) => void;
}

const formMap: Record<
  Nodetype,
  React.ForwardRefExoticComponent<FormProps & React.RefAttributes<HTMLFormElement>>
> = {
  DEFAULT: DefaultNodeForm,
  INTERACTIVE: InteractiveNodeForm,
  HTTP: HttpNodeForm,
  REDIRECT_AGENT: RedirectAgentNodeForm,
  CLOSE: CloseNodeForm
};

const NODE_ICONS: Record<Nodetype, string> = {
  DEFAULT: 'ki-note',
  INTERACTIVE: 'ki-technology-4',
  HTTP: 'ki-router',
  REDIRECT_AGENT: 'ki-user-square',
  CLOSE: 'ki-entrance-left'
};

const NodeSidePanel: React.FC<NodeSidePanelProps> = ({ selectedNode, onSave }) => {
  const formRef = useRef<HTMLFormElement>(null);

  const handleExternalSave = useCallback(() => {
    formRef.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }, []);

  const formType = selectedNode.type as Nodetype;
  const FormComponent = formMap[formType];
  if (!FormComponent) return null;
  const icon = NODE_ICONS[formType];

  return (
    <div className="shadow-sm node-side-panel p-4">
      <div className="d-flex flex-column">
        <div className="flex-grow-1 p-6">
          <Title
            icon={icon}
            title="Configuración del nodo"
            subtitle={`Nodo ID: ${selectedNode.id}`}
            type="primary"
          />
          <div className="separator text-dark mt-4 mb-7" />
          <div className="overflow-auto" style={{ maxHeight: 'calc(100vh - 500px)' }}>
            {FormComponent && (
              <FormComponent
                key={selectedNode.id}
                node={selectedNode}
                onSave={onSave}
                ref={formRef}
              />
            )}
          </div>
        </div>
        <div className="border-top p-6 position-absolute bottom-0 end-0 w-100 country-list">
          <Button
            type="button"
            className="btn btn-light-primary w-100"
            onClick={handleExternalSave}
          >
            <Icon icon="ki-check-circle" size="fs-2" className="me-2" />
            Guardar cambios
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NodeSidePanel;
